import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { EmojiInlineIndexSearch, insertEmoji } from '@platejs/emoji';
import { EmojiPlugin } from '@platejs/emoji/react';

import { Flex } from 'antd';
import type { PlateElementProps } from 'platejs/react';
import { PlateElement, usePluginOption } from 'platejs/react';

import {
	InlineCombobox,
	InlineComboboxContent,
	InlineComboboxEmpty,
	InlineComboboxInput,
	InlineComboboxItem,
	useDebounce,
} from 'features/Editor';

const TRAILING_COLON_REGEX = /:$/;

export function EmojiInputElement(props: PlateElementProps) {
	const { children, editor, element } = props;
	const data = usePluginOption(EmojiPlugin, 'data')!;
	const [value, setValue] = React.useState('');
	const debouncedValue = useDebounce(value, 100);
	const isPending = value !== debouncedValue;

	const filteredEmojis = React.useMemo(() => {
		if (debouncedValue.trim().length === 0) return [];

		return EmojiInlineIndexSearch.getInstance(data).search(debouncedValue.replace(TRAILING_COLON_REGEX, '')).get();
	}, [data, debouncedValue]);

	const { t } = useTranslation();

	return (
		<PlateElement as="span" {...props}>
			<InlineCombobox value={value} element={element} filter={false} setValue={setValue} trigger=":" hideWhenNoValue>
				<InlineComboboxInput />

				<InlineComboboxContent>
					{!isPending && <InlineComboboxEmpty>{t('Ничего не найдено')}</InlineComboboxEmpty>}

					{filteredEmojis.map((emoji) => (
						<InlineComboboxItem key={emoji.id} value={emoji.name} onClick={() => insertEmoji(editor, emoji)}>
							<Flex align="center" gap={8}>
								<span>{emoji.skins[0].native}</span>
								<span>{emoji.name}</span>
							</Flex>
						</InlineComboboxItem>
					))}
				</InlineComboboxContent>
			</InlineCombobox>

			{children}
		</PlateElement>
	);
}
